<template>
  <!-- 修改卖家备注 -->
  <div>
    <el-dialog
      :close-on-click-modal="false"
      title="卖家备注修改"
      :visible.sync="visible"
      width="710px"
      center>
      <div class="y-f y-mb-20 y-f-a">
        <el-select class="y-mr-10 y-f-1" v-model="sellerWordsId" filterable :loading="loadingRemarkData" @change="updateRemark" placeholder="常用备注选择" :clearable="true">
          <el-option
            :label="item.contents"
            v-for="(item, key) in remarkData"
            :key="item.id"
            :value="item.id">
            <div class="y-f y-f-jb">
              <span class="constyle" :title="item.contents">{{ item.contents }}</span>
              <span @click.stop="deleteRemark(remarkData[key])">删除</span>
            </div>
          </el-option>
        </el-select>
        <el-button type="text" size="mini" @click="showRemarkDialog()">添加常用备注</el-button>
      </div>
      <el-input type="textarea" v-model="sellerWordsInput" :autosize="{minRows: 6, maxRows: 10}"  maxlength="200" show-word-limit placeholder="请输入备注，200字以内" :max="200"></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveInfo">保存</el-button>
        <el-button @click="visible = false">取消</el-button>
      </div>
    </el-dialog>
    <!-- 添加备注弹层 -->
    <el-dialog title="添加备注" center :visible.sync="remarkdialogFormVisible" width="500px" :before-close="resetRemarkForm" :close-on-click-modal="false" >
      <el-form :model="remarkForm" ref="remarkForm">
        <el-form-item prop="remark" label="备注内容" :rules="{ required: true, message: '请输入备注内容', trigger: 'blur' }">
          <el-input
            type="textarea"
            v-model="remarkForm.remark"
            class="y-w-320"
            :autosize="{minRows: 6, maxRows: 10}"
            autocomplete="off"
            maxlength="200"
            show-word-limit></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitRemarkFn">确 定</el-button>
        <el-button @click="resetRemarkForm">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { addCustomRemarkApi, deleteCustomRemarkApi, getCustomRemarkListApi } from '@/api/waybillPrint/customPrint';
export default {
  props: {
    fromParentVisible: {
      type: Boolean
    },
    sellerWords: {
      type: String
    },
  },
  data() {
    return {
      visible: true,
      loadingRemarkData: false,
      remarkForm: {
        remark: ''
      },
      remarkdialogFormVisible: false,
      remarkData: [],
      remarkDataMap: {},
      sellerWordsId: '',
      sellerWordsInput: '',
    };
  },
  mounted() {
    this.getRemarkList();
    this.sellerWordsInput = this.sellerWords;
  },
  methods: {
    // 显示添加备注提示框
    showRemarkDialog() {
      if (this.remarkData.length < 20) {
        this.remarkdialogFormVisible = true;
      } else {
        this.$message('自定义备注最多20条。');
      }
    },
    // 用户选择消息模板后
    updateRemark(val) {
      this.sellerWordsInput = this.remarkDataMap[val];
    },
    // 删除备注列表
    deleteRemark(row) {
      this.sellerWordsId = '';
      deleteCustomRemarkApi([row.id]).then(res => {
        if (res.message === 'ok') {
          this.sellerWordsId = '';
          this.getRemarkList();
        }
      });
    },
    // 获取备注列表
    getRemarkList() {
      this.loadingRemarkData = true;
      return getCustomRemarkListApi().then(res => {
        if (res.message === 'ok') {
          this.remarkData = res.data;
          const resData = res.data;
          this.remarkDataMap = {};
          if(resData.length) {
            resData.forEach(item => {
              this.remarkDataMap[item.id] = item.contents;
            })
          }
          this.loadingRemarkData = false;
        }
      });
    },
    saveInfo() {
      let params = {
        sellerWords: this.sellerWordsInput
      }
      this.$emit('saveInfo', params);
    },
    resetRemarkForm() {
      this.remarkdialogFormVisible = false;
      this.remarkForm.remark = '';
    },
    submitRemarkFn() {
      this.$refs.remarkForm.validate((valid) => {
        if (valid) {
          let params = [{contents: this.remarkForm.remark}];
          addCustomRemarkApi(params).then(res => {
            if (res.message === 'ok') {
              this.resetRemarkForm();
              this.$message({
                message: '添加备注成功',
                type: 'success'
              });
              this.getRemarkList(); // 更新备注列表
            } else {
              this.$message.error('添加备注信息失败！');
            }
          });
        }
      });
    }
  },
  watch: {
    visible(val) {
      this.$emit('update:fromParentVisible', val)
    }
  }
};
</script>
<style lang="scss" scoped>
.constyle {
  max-width:500px;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
